import { useCallback, useState } from 'react';

import { getLocalStorageItem, setLocalStorageItem } from '@atlassian/search-common';

import { type BulkConnectState, DEFAULT_BULK_CONNECT_STATE } from '../../constants/3p-bulk-connect';

export const SEARCH_PAGE_BULK_CONNECT_KEY = 'search-page-bulk-connect';

export const useBulkConnectLocalStorage: () => [
	BulkConnectState,
	(value: BulkConnectState) => void,
] = () => {
	const [storedState, setStoredState] = useState<BulkConnectState>(
		getLocalStorageItem(SEARCH_PAGE_BULK_CONNECT_KEY) || DEFAULT_BULK_CONNECT_STATE,
	);

	const setState = useCallback(
		(newState: BulkConnectState) => {
			setStoredState(newState);
			setLocalStorageItem(SEARCH_PAGE_BULK_CONNECT_KEY, JSON.stringify(newState));
		},
		[setStoredState],
	);

	return [storedState, setState];
};
